/** PrimeNG filterBy — ko‘p tilli obyekt va oddiy string label uchun. */
export function multiLangFilterBy(field = 'label'): string {
  return `${field},${field}.uz,${field}.ru,${field}.en,${field}.kaa`;
}
